import React from 'react';

// Simple toast implementation
const toastState = {
  listeners: [],
  toasts: [],
};

export const useToast = () => {
  const [, forceUpdate] = React.useReducer(x => x + 1, 0);

  React.useEffect(() => {
    toastState.listeners.push(forceUpdate);
    return () => {
      toastState.listeners = toastState.listeners.filter(l => l !== forceUpdate);
    };
  }, []);

  const toast = ({ title, description, variant = 'default' }) => {
    const id = Date.now() + Math.random();
    const newToast = { id, title, description, variant };
    
    toastState.toasts.push(newToast);
    toastState.listeners.forEach(listener => listener());

    // Auto remove after 3 seconds
    setTimeout(() => {
      toastState.toasts = toastState.toasts.filter(t => t.id !== id);
      toastState.listeners.forEach(listener => listener());
    }, 3000);
  };

  return { toast, toasts: toastState.toasts };
};

export const Toaster = () => {
  const { toasts } = useToast();

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`
            p-4 rounded-lg shadow-premium-lg border animate-slide-in
            ${toast.variant === 'destructive' 
              ? 'bg-red-50 border-red-200 text-red-900' 
              : 'bg-white border-gray-200 text-gray-900'
            }
          `}
          style={{ minWidth: '300px', maxWidth: '400px' }}
        >
          {toast.title && (
            <p className="font-semibold mb-1">{toast.title}</p>
          )}
          {toast.description && (
            <p className="text-sm opacity-90">{toast.description}</p>
          )}
        </div>
      ))}
    </div>
  );
};
